/**
 * Module dependencies.
 */

import { AxiosInstance } from 'axios';
import { UseMutationOptions, useMutation } from '@tanstack/react-query';
import { resolveAppUrl } from 'app/core/utils/url-resolver';
import { useRequestProvider } from 'app/components/providers/request-provider/request-provider';

/**
 * `Credentials` type.
 */

export type Credentials = { email: string; password: string };

/**
 * Password login.
 */

function passwordLogin(client: AxiosInstance, payload: Credentials): Promise<void> {
  return client.post(resolveAppUrl('login'), payload).then(({ data }) => data);
}

/**
 * `Options` type.
 */

type Options = UseMutationOptions<void, unknown, Credentials, unknown>;

/**
 * Export `usePasswordLogin`.
 */

export function usePasswordLogin(options?: Options) {
  const client = useRequestProvider();

  return useMutation({
    mutationFn: async (payload: Credentials) => {
      return await passwordLogin(client, payload);
    },
    ...options
  });
}
